// Legacy video settings with exact aspect ratio constraint
export const legacyVideoSettings = {
  width: {
    max: 1280, // Cap at 1280x960 (4:3 legacy max)
  },
  height: {
    max: 960,
  },
  aspectRatio: {
    exact: 4 / 3,
  },
  // No min: mandatory frameRate.min causes OverconstrainedError on low-fps/throttled cameras.
  frameRate: { ideal: 30, max: 30 },
};

// 720p equivalent with 4:3 aspect ratio (960x720)
export const video720pSettings = {
  width: {
    ideal: 960, // 720p equivalent width for 4:3
    max: 960, // Cap at 720p width
  },
  height: {
    ideal: 720, // 720p height
    max: 720, // Cap at 720p height
  },
  aspectRatio: {
    ideal: 4 / 3,
  },
  frameRate: { ideal: 30, max: 30 },
};

// 1080p equivalent with 4:3 aspect ratio (1440x1080)
export const video1080pSettings = {
  width: {
    ideal: 1440, // 1080p equivalent width for 4:3
    max: 1440, // Cap at 1080p width
  },
  height: {
    ideal: 1080, // 1080p height
    max: 1080, // Cap at 1080p height
  },
  aspectRatio: {
    ideal: 4 / 3,
  },
  frameRate: { ideal: 30, max: 30 },
};

// Helper function to get video settings based on resolution flag
export const getVideoSettingsByResolution = (resolution?: string) => {
  // Clean the resolution string by removing any surrounding quotes
  const cleanResolution = resolution?.replaceAll('"', '');

  switch (cleanResolution) {
    case '720p':
      return video720pSettings;
    case '1080p':
      return video1080pSettings;
    default:
      return legacyVideoSettings;
  }
};

// Default export will be determined by feature flag usage
export const videoSettings = legacyVideoSettings;
